import * as yup from 'yup';

function warrantyType(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_WARRANTYTYPE_FIELD_IS_REQUIRED',
        defaultMessage: 'Warranty Type is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'EDITFORM_WARRANTYTYPE_FIELD_MAX_CHARS_64',
        defaultMessage: 'Warranty Type should be less than 64 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      warrantyType: warrantyType(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
